import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import apiEndPoints from 'utils/apiEndPoints';
import { apiCall } from 'utils/httpClient';
import { successToast,errorToast } from 'utils/httpClient';
// Modal Component
const AllocateCP = ({ show, smData,AllCps, handleClose }) => {
  const dispatch = useDispatch();
  const [selectedCps, setSelectedCps] = useState([]); // Selected properties (checked)
  const [allCpList, setAllCpList] = useState([]); // All available properties
  const [allCps, setAllCps] = useState([]); // Properties that are checked
  

  const channelPartnerListSelector = useSelector(
    (state) => state?.channelPartner
  );
  const [searchQuery, setSearchQuery] = useState('');

  // Filtered list based on search query
  const filteredCpList = allCpList.filter((cp) =>
    cp?.agency_name.toLowerCase().includes(searchQuery.toLowerCase())
  );


  // Fetch all properties on component mount or on cp_id change

   useEffect(() => {
    if (allCpList.length === 0 && AllCps && AllCps.length > 0) {
      setAllCpList(AllCps); // Set allCpList with AllCps if it's empty
    }
  }, [AllCps, allCpList]);
//   useEffect(() => {
//     if (AllpropertySelector?.response && AllpropertySelector?.response?.status === 200) {
//         const activeProperties = AllpropertySelector?.response?.data?.filter(property => property.status === true);
//       setAllPropertyList(activeProperties); // Store all properties
//     } else {
//       setAllPropertyList([]);
//     }
//   }, [AllpropertySelector]);



  useEffect(() => {
    const fetchCp = async () => {
     // Debugging output
  
     
            const list = allCpList?.filter((o1) =>
             o1?.parent_id === smData?._id
            );
            setAllCps(list); // Store filtered properties based on cp_id
          } 
  
  
    if (smData?._id) {
      fetchCp();
    }
  }, [allCpList, smData?._id]); // Only trigger when cp_id changes, not when allPropertyList changes
  

  // Handle checkbox change
  // const handleCheckboxChange = (cp) => {
  //   setSelectedCps((prevSelected) => {
  //     const isSelected = prevSelected.some((item) => item._id === cp._id);
  
  //     // If the property is already selected, unselect it (set status to false)
  //     if (isSelected) {
  //       return prevSelected.map((item) =>
  //         item._id === cp._id
  //           ? { ...item, status: false } // Set status to false when unselected
  //           : item
  //       );
  //     } else {
  //       // If the property is not selected, select it (set status to true)
  //       return [
  //         ...prevSelected,
  //         { ...cp, status: true }, // Set status to true when selected
  //       ];
  //     }
  //   });
  // };

  const handleCheckboxChange = (cp) => {
    setSelectedCps((prevSelected) => {
      const isSelected = prevSelected.some((item) => item._id === cp._id);
  
      // If the property is already selected, unselect it and remove it from the list
      if (isSelected) {
        return prevSelected
          .filter((item) => item._id !== cp._id); // Remove the item entirely
      } else {
        // If the property is not selected, add it with status true
        return [
          ...prevSelected,
          { ...cp, status: true }, // Set status to true when selected
        ];
      }
    });
  };
  

  // Automatically check properties in allProperty if they exist in allPropertyList
  useEffect(() => {
    // Sync selected properties with allProperty
    if (allCpList.length > 0) {
      const selected = allCpList.filter((cp) =>
       
        allCps.some((selectedCp) => selectedCp._id === cp._id)
      );
     
      setSelectedCps(selected);
    }
  }, [allCps, allCpList]);

  // Handle "Save Changes" click, pass selected properties to parent if cp_id is not available
  const handleSaveChanges = async() => {
    
      // Prepare parameters for the API call
      const params = {
        cp_id: selectedCps.map((cp) => cp._id),
        user_id: smData?._id
      };
    
      try {
        // Make the API call
        const response = await apiCall("post", apiEndPoints.CPASSIGNSOURCINGMANAGER, params);
    
        // Handle successful response
        if (response?.data?.status === 200) {
          successToast(response?.data?.message); // Show success message
        } else {
          // Handle error response
          errorToast(response?.data?.message); // Show error message
        }
      } catch (error) {
        // Handle any errors during the API call
        errorToast(error);
      }
    
      handleClose()
    
  
  };

  // Return null if modal is not shown
  if (!show) return null;

  return (
    <>
      {/* Backdrop with blur effect */}
      <div
        className="modal-backdrop"
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.5)', // Semi-transparent background
          backdropFilter: 'blur(5px)', // Blur effect on the background
          zIndex: 1040,
        }}
      ></div>

      {/* Modal Dialog */}
      <div className="modal show" style={{ display: 'block', zIndex: 1050 }} tabIndex="-1">
        <div className="modal-dialog modal-lg">
          <div className="modal-content" style={{ height: '80vh' }}>
            <div className="modal-header">
              <h5 className="modal-title">Allocate Cp</h5>
              <button type="button" className="close" onClick={handleClose}>
                <span>&times;</span>
              </button>
            </div>
            <div className="modal-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
              {/* Display selected properties in a box */}
              <div
                style={{
                  border: '1px solid #ccc',
                  padding: '10px',
                  marginBottom: '20px',
                  minHeight: '60px',
                  backgroundColor: '#f9f9f9',
                }}
              >
                <strong>Selected CPs:</strong>
                <div
                  style={{
                    display: 'flex',
                    flexWrap: 'wrap', // Allow wrapping when items exceed container width
                    gap: '10px', // Space between each selected property
                  }}
                >
                  {selectedCps.length === 0
                    ? 'No Cp selected'
                    : selectedCps.map((cp, index) => (
                        <div
                          key={index}
                          style={{
                            border: '1px solid #007bff', // Border for each selected property
                            padding: '5px 10px',
                            backgroundColor: '#e7f1ff', // Light background color
                            borderRadius: '4px', // Rounded corners for each selected property
                          }}
                        >
                          {cp?.agent_name}
                        </div>
                      ))}
                </div>
              </div>
              <div style={{ marginBottom: '20px' }}>
              <input
                type="text"
                placeholder="Search by Agency Name"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                style={{
                  padding: '8px',
                  width: '100%',
                  boxSizing: 'border-box',
                  border: '1px solid #ccc',
                  borderRadius: '4px',
                }}
              />
            </div>
              {/* List of properties with checkboxes */}
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                {filteredCpList?.map((cp) => (
                  <div
                    key={cp?._id}
                    style={{
                      flex: '0 0 48%', // Set each item to take up 48% of the container width
                      boxSizing: 'border-box', // Ensure padding/border doesn't affect the width calculation
                    }}
                  >
                    <label style={{ display: 'flex', alignItems: 'center' }}>
                      <input
                        type="checkbox"
                        checked={selectedCps.some((p) => p._id === cp._id && p.status === true)} // Check if the property is selected
                        onChange={() => handleCheckboxChange(cp)}
                      />
                      <span style={{ marginLeft: '10px' }}>{cp?.agency_name}</span>
                    </label>
                  </div>
                ))}
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={handleClose}>
                Close
              </button>
              <button type="button" className="btn btn-primary" onClick={handleSaveChanges}>
                Save Changes
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AllocateCP;

